import React from 'react';

import AdBudgetLimit from './index';

export type BudgetLimitsModalProps = {
  /** Whether the modal is open. */
  isOpen: boolean;
  /** Called when the modal requests to close (backdrop click, escape, close button). */
  onClose: () => void;
};

/**
 * "Ad Budget & Limits" modal. `AdBudgetLimit` now renders inside the shared
 * `Overlay` (centred popup on desktop, animated bottom sheet on mobile, themed
 * backdrop + drop shadow + Escape / backdrop-close / scroll-lock), so this is just
 * the open gate. Both the acquisition `ChannelsBudgets` card and the channel-detail
 * page render it identically.
 */
const BudgetLimitsModal = ({ isOpen, onClose }: BudgetLimitsModalProps): React.ReactElement | null =>
  isOpen ? <AdBudgetLimit onCloseBudgetLimits={onClose} /> : null;

export default BudgetLimitsModal;
